export default __webpack_public_path__ + "static/sampling-config-light-mode-150a22bbb25726cbde395e7d42aafcfb.png";